import { gql } from '@apollo/client';

export const BATCH_SUBJECT_CONFIGURATION = gql`
  query batch_subject_configuration($where: batch_subject_configuration_bool_exp) {
    batch_subject_configuration(where: $where) {
      id
      hoursPerSlot
      minutesPerSlot
      totalSlots
      batch_subject_extra_slots {
        id
        name
        hoursPerSlot
        minutesPerSlot
        totalSlots
        totalMarks
      }
    }
  }
`;

export const INSERT_BATCH_SUBJECT_CONFIGURATION = gql`
  mutation insert_batch_subject_configuration_one($object: batch_subject_configuration_insert_input!) {
    insert_batch_subject_configuration_one(object: $object) {
      id
    }
  }
`;

export const UPDATE_BATCH_SUBJECT_CONFIGURATION = gql`
  mutation update_batch_subject_configuration(
    $where: batch_subject_configuration_bool_exp!
    $_set: batch_subject_configuration_set_input
  ) {
    update_batch_subject_configuration(where: $where, _set: $_set) {
      affected_rows
    }
  }
`;

export const UPDATE_BATCH_SUBJECT_EXTRA_SLOT = gql`
  mutation update_batch_subject_extra_slot(
    $where: batch_subject_extra_slot_bool_exp!
    $_set: batch_subject_extra_slot_set_input
  ) {
    update_batch_subject_extra_slot(where: $where, _set: $_set) {
      affected_rows
    }
  }
`;

export const DELETE_BATCH_SUBJECT_EXTRA_SLOT = gql`
  mutation delete_batch_subject_extra_slot($where: batch_subject_extra_slot_bool_exp!) {
    delete_batch_subject_extra_slot(where: $where) {
      affected_rows
    }
  }
`;

export const INSERT_BATCH_SUBJECT_EXTRA_SLOTS = gql`
  mutation insert_batch_subject_extra_slots($objects: [batch_subject_extra_slot_insert_input!]!) {
    insert_batch_subject_extra_slot(objects: $objects) {
      affected_rows
    }
  }
`;

export const BATCH_SUBJECT_CONFIGURATION_FOR_RESULT_SHEET = gql`
  query batchSubjectConfigurationForResultSheet($where: batch_subject_configuration_bool_exp!) {
    batch_subject_configuration(where: $where) {
      id
      subject {
        id
        name
        code
      }
      batch_subject_extra_slots {
        id
        name
        totalMarks
      }
      assessments {
        id
        title
        totalMarks
      }
    }
  }
`;

export const SUBJECT_COORDINATORS_FOR_RESULT_SHEET = gql`
  query subjectCordinatorsForResultSheet($where: batch_subject_configuration_bool_exp) {
    batch_subject_configuration(where: $where) {
      subject {
        course_semester_subjects_subjects {
          course_semester {
            course_coordinators {
              userId
            }
          }
        }
      }
    }
  }
`;
